export default __webpack_public_path__ + "static/media/charmin.0230beb1.jpg";